import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './MainNavigation.module.scss';

interface Props {
  links: any[];
  className?: string;
  showIncompleteDetailsAlert?: any;
}

const SPA_PATH = 'portal';

const MainNavigation = ({
  links,
  className,
  showIncompleteDetailsAlert,
}: Props) => {
  const { origin } = window.location;

  const [openMenu, setOpen] = useState('');
  const [show, setShow] = useState(false);
  const dropDownMenu = (e: any) => {
    let current = e.target.getAttribute('data-value');
    let showelement = e.target.getAttribute('data-attr');
    console.log(openMenu);

    if (openMenu !== current) {
      setOpen(e.target.getAttribute('data-value'));
      setShow(true);
    } else {
      if (showelement == 'true') {
        setOpen('');
        setShow(false);
      }
    }
  };
  return (
    <div className={classNames(styles.wrapper, className)}>
      {(links || []).map((link, index) => {
        if ((link.url || '').includes(SPA_PATH)) {
          if (link.pageTypeName !== "ArticlePage") {
            return (
              <NavLink
                key={index}
                to={link.url}
                className={classNames(
                  styles.link,
                  link.pageTypeName === 'CustomerProfilePageData' &&
                  showIncompleteDetailsAlert &&
                  styles.showAlert,
                )}
              >
                {link.name}
              </NavLink>
            );
          }
        }
        if (link?.childItems?.length > 0) {
          let subMenus = link.childItems.map((sublink: any) => {
            return (
              <li>
                <a
                  href={origin + sublink.Link}
                  className={styles.dropdown_item}
                >
                  {sublink.PageData?.Name}
                </a>
              </li>
            );
          });
          return (
            // <nav className="PageNav">
            //   <ul className="PageNav-list">
            //     <li className={classNames(styles.PageNav_item, styles.dropdown, showSubmenu?styles.drop_active:'')}>
            //       <a href="javascript:void(0)" className={styles.PageNav_itemLink} onClick={()=>dropDownMenu()}>
            //         {link.name}
            //       </a>
            //       <ul className={classNames(styles.dropdown_menu, styles.dropdown_uk)}>
            //         {subMenus}
            //       </ul>
            //     </li>
            //   </ul>
            // </nav>
            <button
              className={classNames(
                styles.link,
                styles.dropdown,
                openMenu === link.name ? styles.active : '',
              )}
              onClick={dropDownMenu}
              data-value={link.name}
              data-attr={show}
            >
              {link.name}

              <ul
                className={classNames(
                  styles.dropdown_menu,
                  styles.dropdown_uk,
                  openMenu === link.name ? styles.dropactive : '',
                )}
              >
                {subMenus}
              </ul>
            </button>
          );
        } else {
          if (link.pageTypeName !== "ArticlePage") {
            return (
              <a href={origin + link.url} className={styles.link}>
                {link.name}
              </a>
            );
          }
        }
      })}
    </div>
  );
};

export default MainNavigation;
